import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  List,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BulkDeleteButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';
import DateInput from '../../../../components/DateInput';
import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import exporter from '../../../../utils/exporter';
import docUpdate from '../docUpdate';
import PostPagination from '../../../../utils/pagination';
import SendOrderButton from './SendOrderButton';
const ResourceIcon = BookmarkIcon;

const listStyles = {};

// Переиспользуемый компонент для локализации значения поля description
const LocalizedDescriptionField = translate(({ record, translate }) => (
  <span>
    {record && typeof record.description === 'string'
      ? translate(`resources.${resourceConfig.name}.descriptions.${record.description}`, { _: record.description })
      : ''}
  </span>
));


const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <docUpdate.Button {...props} bulk docType={'DOC'} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'journalName'} />

    <DateInput
      source={'dateCreate'}
      label={`resources.${resourceConfig.name}.fields.dateCreate`}
    />
  </Filter>
);

const ResourceListActions = ({
  bulkActions,
  basePath,
  displayedFilters,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    actions={<ResourceListActions />}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'journalName'} />
      <TextField source={'dateCreate'} />
      <TextField source={'username'} />
      <LocalizedDescriptionField label={translate(`resources.${resourceConfig.name}.fields.description`)} />
      <SendOrderButton source={'path'}/>
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));



const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      acceptance_date: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
      document_date: {
        type: 'dateTime',
        sortingField: 'documentDate',
      },
      transferDate: {
        type: 'dateTime',
      },
      withdrawalDate: {
        type: 'dateTime',
      },
    },
    filters: {
      processedDate: {
        type: 'dateTime',
      },
      document_date: {
        type: 'dateTime',
      },
      document_date_to: {
        type: 'dateTime',
      },
      document_date_from: {
        type: 'dateTime',
      },
      transferDate: {
        type: 'dateTime',
      },
      documentDatesFrom: {
        type: 'dateTime',
      },
      documentDatesTo: {
        type: 'dateTime',
      },
    },
  },
};
